module.exports = __webpack_public_path__ + "media/images/menu/icn-cart-ab4d262a351f19dd738ab0b7213a8eda.svg";